import React from 'react';
import truckImage from '../../assets/images/crop-architect-opening-blueprint.jpg';

export const HeroHome = () => {
  return (
    <section className="HeroSection bg-white overflow-hidden w-full mx-auto flex items-center justify-center pt-[113px] max-w-[100vw]">
      {/* Background Image and Text Content Container */}
      <div className="relative w-full h-[60vh] lg:h-[80vh] xl:h-[90vh] 2xl:h-[992px] flex items-center justify-center">
        {/* Background Image */}
        <img
          src={truckImage}
          alt="Fast and safe transportation services"
          className="w-full h-full object-cover absolute inset-0"
          style={{ aspectRatio: '1781.04 / 992' }}
          loading="lazy"
        />
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(245deg, rgba(0, 0, 0, 0) 23.99%, #000 99.36%)',
            mixBlendMode: 'multiply',
          }}
        />

        {/* Text Content */}
        <div className="relative z-20 px-4 sm:px-8 md:px-12 xl:px-24 2xl:px-48 w-full max-w-screen-2xl">
          <div className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight max-w-[800px]">
            <span className="text-white">Seamless</span>
            <span className="text-[#5bc0fe]"> Services</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHome;
